<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/interconsulta">Interconsultas</router-link> > Paciente: {{ datoInterconsulta.paciente }}
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help</span>
        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp">
      <AyudaAtencionForm />
    </Modal>
    <Modal v-model:modelValue="showModal">
      <ResumenAtencion :p_idAtencion="datoInterconsulta.idAtencion"/>
    </Modal>
    <hr>
    <!-- Modal -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body form-card">
            <!--             <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInterconsulta.idInterconsulta" disabled>
                </div>
              </div>
            </div> -->
            <!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoInterconsulta.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="medicoAtencion" class="form-label">Médico</label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control" id="medicoAtencion" name="medicoAtencion  "
                    v-model="datoInterconsulta.medicoAtencion" disabled>
                </div>
                <div class="col-1">
                  <label for="estadoInter" class="form-label">Estado</label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control" id="estadoInter" name="estadoInter"
                    v-model="datoInterconsulta.estadoInter" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-11">
                  <textarea class="form-control" id="motivo" name="motivo" v-model="datoInterconsulta.motivo"
                    disabled></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-11">
                  <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInterconsulta.cuadro"
                    disabled></textarea>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!--
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarInterconsulta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInterconsulta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
-->
      </div>
    </div>

    <div class="mb-3">
      <div class="row mb-2">
        <div class="col-md-3">
          <button type="button" class="btn btn-light w-100" @click="showModal = true" title="Ver Atención y notas clínicas">
            <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;">clinical_notes</span>
            Ver Atención
          </button>
        </div>
        <div class="col-md-3">
          <button type="submit" class="btn btn-light w-100" 
                  @click.prevent="actualizarEstado('PROCESO')" 
                  title="Iniciar Interconsulta"
                  :disabled="datoInterconsulta.estadoInter !== 'ASIGNADA'">
            <span class="material-symbols-outlined" 
                  :style="{ fontSize: '32px', color: datoInterconsulta.estadoInter !== 'ASIGNADA' ? 'gray' : 'blue', cursor: 'pointer' }">
              play_arrow
            </span>
            Iniciar
          </button>
        </div>
        <div class="col-md-3">
          <router-link
            :to="'/informeinterform/' + datoInterconsulta.idAtencion + '/' + datoInterconsulta.idInterconsulta"
            class="btn btn-light w-100" 
            title="Editar Informe"
            :class="{ disabled: (datoInterconsulta.estadoInter !== 'PROCESO')}">
            <span class="material-symbols-outlined"
                  :style="{ fontSize: '32px', color: datoInterconsulta.estadoInter != 'PROCESO' ? 'gray' : 'orange', cursor: 'pointer' }">
              edit_document
            </span>
            Editar
          </router-link>
        </div>
        <div class="col-md-3">
          <button type="submit" class="btn btn-light w-100" 
                  @click.prevent="actualizarEstado('CANCELADA')" 
                  title="Cancelar Interconsulta"
                  :disabled="!(datoInterconsulta.estadoInter === 'PROCESO')">
            <span class="material-symbols-outlined" 
                  :style="{ fontSize: '32px', color: datoInterconsulta.estadoInter !== ' PROCESO' ? 'gray' : 'red', cursor: 'pointer' }">
              cancel
            </span>
            Cancelar
          </button>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-3">
          <button type="submit" class="btn btn-light w-100" 
                  @click="formulario007solicitudPDF()" 
                  title="Formulario 007 - Solicitud">
            <span class="material-symbols-outlined" style="font-size:32px;color:green; cursor: pointer;">
              quick_reference_all
            </span>
            Formulario 007 - Solicitud
          </button>
        </div>
        <div class="col-md-3">
          <button type="submit" class="btn btn-light w-100" 
                  @click="formulario007informePDF()" 
                  title="Formulario 007 - Informe" 
                  :disabled="datoInterconsulta.estadoInter !== 'FINALIZADA'">
            <span class="material-symbols-outlined" 
                  :style="{ fontSize: '32px', color: datoInterconsulta.estadoInter !== 'FINALIZADA' ? 'gray' : 'green', cursor: 'pointer' }">
              quick_reference_all
            </span>
            Formulario 007 - Informe
          </button>
        </div>
        <div class="col-md-3">
        </div>
        <div class="col-md-3">
          <button type="submit" class="btn btn-light w-100" 
                  @click.prevent="actualizarEstado('RECHAZADA')" 
                  title="Rechazar Interconsulta"
                  :disabled="!(datoInterconsulta.estadoInter === 'PROCESO')">
            <span class="material-symbols-outlined" 
                  :style="{ fontSize: '32px', color: datoInterconsulta.estadoInter !== 'PROCESO' ? 'gray' : 'red', cursor: 'pointer' }">
              comments_disabled
            </span>
            Rechazar
          </button>
        </div>
      </div>
    </div>

    <!-- Formulario 007 - Solicitud -->
    <Modal v-model:modelValue="showModalSolicitud">
      <DocVerFirmarGuardar :idReporte="3" :idDocumento="p_idInterconsulta" />
    </Modal>

    <!-- Formulario 007 - Informe -->
    <Modal v-model:modelValue="showModalInforme">
      <DocVerFirmarGuardar :idReporte="4" :idDocumento="p_idInterconsulta" />
    </Modal>
	
    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AyudaAtencionForm from '@/views/ayuda/AyudaAtencionForm.vue'
import ResumenAtencion from '@/views/reportes/AtencionResumen.vue';
import DocVerFirmarGuardar from '../utils/DocVerFirmarGuardar.vue'

import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'
export default {
  components: {
    Layout, Footer, AyudaAtencionForm, ResumenAtencion, DocVerFirmarGuardar
  },
  data() {
    return {
      interconsultas: [],
      datoInterconsulta: {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      p_idInterconsulta: 0,
      showTable: 'biomAten',
      showModal: false,
      showModalHelp: false,
      showModalSolicitud: false,
      showModalInforme:   false,
    }
  },
  watch: {
    '$route.query.refresh': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getData();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.p_NumeroAtencion = this.$route.params.p_numero_atencion
    this.p_idInterconsulta = this.$route.params.p_idinterconsulta
    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getData() {
      api.get('/vwinterconsultas/destino/' + this.p_idInterconsulta)
        .then(response => {
          this.datoInterconsulta = response.data;
        })
        .catch(error => {
          console.error('Error al obtener datos de la persona:', error);
        });
    },
    async actualizarEstado(estado) {
      try {
        await api.put('/interconsultas/actualizar-estado/' + this.p_idInterconsulta + '/' + estado)
        swal("Correcto!", "Interconsulta actualizada!", "success");
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error");
        var array = Object.values(error.response.data.errors)
        array.forEach(element => swal(String(element)))
      }
      if(this.datoInterconsulta.estadoInter === 'ASIGNADA'){
        this.$router.push('/interconsultadestinoform/'+this.p_NumeroAtencion+'/'+this.p_idInterconsulta+'?refresh=' + new Date().getTime())
      }
      else{
        this.$router.push('/interconsulta');
      }
    },

    formulario007solicitudPDF() {
      this.showModalSolicitud = true;
    },
    formulario007informePDF() {
      this.showModalInforme = true;
    },
  
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    }
  },
}
</script>
<style src="@/assets/css/tabs.css" scoped></style>